import en from "application/messages/en.json";
import fr from "application/messages/fr.json";
import getLang from "module/functions/getLang";
import getCountry from "module/functions/getCountry";

const country = getLang() || getCountry() || navigator.language || navigator.userLanguage;
const language = country ?? "gb";

const countries = ["de", "fr", "gb", "es"];

const exportedMessages = language === "gb" || !countries.includes(language) ? { en } : { en, fr };

export default exportedMessages;
